import { ErrorBoundary } from './ErrorBoundary';
import { ErrorMessage } from './ErrorMessage';

ErrorBoundary.Message = ErrorMessage;

export { ErrorBoundary };
